














import { defineComponent, PropType } from '@vue/composition-api';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { HomeBanner } from '@/types/home';
import { useJumpInfo } from '../use-jumpinfo';

export default defineComponent({
  name: 'RightTopBanner',
  components: {
    MultiJumpContainer,
  },
  props: {
    rightTopBanner: {
      type: Object as PropType<HomeBanner>,
      required: false,
    },
  },
  setup(props) {
    const { jumpInfo } = useJumpInfo(props.rightTopBanner);
    return {
      jumpInfo,
    };
  },
});
